<div *ngIf="displayCurve">
  <ngx-charts-bubble-chart [view]="view" [results]="results" [scheme]="scheme" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel"
    [yAxis]="yAxis" [xAxis]="xAxis" [showYAxisLabel]="showYAxisLabel" [showXAxisLabel]="showXAxisLabel" [autoScale]="autoScale"></ngx-charts-bubble-chart>
</div>